export default {
	"primary-highlight-color": "#066",
	"secondary-highlight-color": "#003d3d",
	"main-color": "#efefef",
	"bg-color": "#1a1a1a",
	"accent-color": "#3a3a3a"
};
